import styled from '@emotion/styled';
import { keyframes, css } from 'emotion';

import { getThemeColor } from '@ezugi/ui/theme';

const getScaleByTimeLeft = (totalTime: number, timeLeft: number) => 1 / (totalTime / timeLeft);

const progressBarKeyframe = (scale: number) => keyframes`
  from {
    transform: scaleX(${scale});
  }
  to {
    transform: scaleX(0);
  }
`;

export const progressBarAnimation = (totalTime: number, timeLeft: number) => css`
  &::before {
    animation: ${progressBarKeyframe(getScaleByTimeLeft(totalTime, timeLeft))} ${timeLeft}s linear;
  }
`;

export const noProgressAnimation = css`
  &::before {
    animation: none;
  }
`;

export const Container = styled.div`
  height: 30px;
  position: relative;
  overflow: hidden;
  background: ${getThemeColor('primary')};
  color: ${getThemeColor('primaryContrast')};
  fill: ${getThemeColor('primaryContrast')};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
  tansfrom-origin: left;
  transition: color 0.27s linear, transform 0.27s linear;
  border-radius: 8px;

  &:before {
    transform-origin: left;
    will-change: transform;
    position: absolute;
    inset: -5px;
    content: "";
    width: 100%;
    background-color: ${({ color }) => color};
  }
`;

export const GameStatusLabel = styled.span`
  position: relative;
  color: #fff;
  z-index: 1;
`;
